import './installCrmErrorReporting';
import { reportCrmError } from './lib/crmErrors';
import { productionCrmNavigationTarget, productionProviderCallback } from './lib/productionCrmNavigation.mjs';
import './oauthHandoff';
import { shouldDeferReactBootstrapForNativeOAuthHandoff } from './lib/capacitorZitadelUrls';

/**
 * Do not statically import `./App` here. On the IdP HTTPS redirect document,
 * that would still evaluate `App.tsx` and construct `UserManager` before the
 * `if` runs — wrong localStorage partition for PKCE/state.
 */
const canonicalTarget = productionCrmNavigationTarget(import.meta.env, window.location, window.self === window.top);
if (canonicalTarget) {
  window.location.replace(canonicalTarget);
} else if (productionProviderCallback(import.meta.env, window.location)) {
  // Provider callbacks carry signed state to an existing trusted opener/relay.
  // They must not probe the ambient CRM session on the registered legacy host.
  void import('./bootstrapProviderCallbacks');
} else if (!shouldDeferReactBootstrapForNativeOAuthHandoff()) {
  void import('./bootstrapApp').catch(error => { reportCrmError('bootstrap', error); throw error; });
}
